function StatisticIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.6699 6.94942C21.0299 4.77942 19.2199 2.96942 17.0499 2.32942C15.3999 1.84942 14.2599 1.88942 13.4699 2.47942C12.5199 3.18942 12.4099 4.46942 12.4099 5.37942V7.86942C12.4099 10.3294 13.5299 11.5794 15.7299 11.5794H18.5999C19.4999 11.5794 20.7899 11.4694 21.4999 10.5194C22.1099 9.73942 22.1599 8.59942 21.6699 6.94942Z"
        fill="#5570F1"
      />
      <path
        d="M18.9099 13.3611C18.6499 13.0611 18.2699 12.8911 17.8799 12.8911H14.2999C12.5399 12.8911 11.1099 11.4611 11.1099 9.70113V6.12113C11.1099 5.73113 10.9399 5.35113 10.6399 5.09113C10.3499 4.83113 9.9499 4.71113 9.5699 4.76113C7.2199 5.06113 5.0599 6.35113 3.6499 8.29113C2.2299 10.2411 1.7099 12.6211 2.1599 15.0011C2.8099 18.4411 5.5599 21.1911 9.0099 21.8411C9.5599 21.9511 10.1099 22.0011 10.6599 22.0011C12.4699 22.0011 14.2199 21.4411 15.7099 20.3511C17.6499 18.9411 18.9399 16.7811 19.2399 14.4311C19.2899 14.0411 19.1699 13.6511 18.9099 13.3611Z"
        fill="#5570F1"
      />
    </svg>
  );
}

export default StatisticIcon;
